import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
export const StripeCheckoutError = () => {
    const navigate = useNavigate();
    const handleBack = () => {
        navigate('/salesWizard');
    };
    return (React.createElement(Box, { textAlign: "center", mt: 4 },
        React.createElement(CancelIcon, { sx: { fontSize: 80, color: 'error.main' } }),
        React.createElement(Typography, { variant: "h5", fontWeight: 500, mt: 2 }, "We are sorry, an error occurred."),
        React.createElement(Typography, { variant: "body1", mt: 1 }, "We are unable to process the payment, please make sure your card is funded and try again."),
        React.createElement(Button, { variant: "contained", color: "primary", sx: {
                mt: 2,
                px: 2,
                fontWeight: 500,
                borderRadius: '12px',
                textTransform: 'none',
            }, onClick: handleBack }, "Retry Payment")));
};
